import { FunctionComponent } from 'react';

import styles from './RAStep.module.sass';

export interface RAStepProps {
    image: string;
    title: string;
    description: string;
}

const RAStep: FunctionComponent<RAStepProps> = ({ image, title, description }) => {
    return (
        <div className={styles.container}>
            <img className={styles.image} src={image} alt={title} />
            <div className={styles.innerTitle}>{title}</div>
            <div className={styles.description}>{description}</div>
        </div>
    );
};

export default RAStep;
